import React from 'react';
import PropTypes from 'prop-types';
import { Avatar as MuiAvatar } from '@mui/material';
import styled from 'styled-components';

const Avatar = styled(({ className, ...props }) => (
  <MuiAvatar src={props.src}{...props} className={className} />
))`
  && {
    width: ${(props) =>
            props.size === 'small'
                    ? props.theme.spacing(4)
                    : props.size === 'medium'
                            ? props.theme.spacing(6)
                            : props.size === 'xlarge'
                                    ? props.theme.spacing(14)
                                    : props.theme.spacing(12)} ;
    height: ${(props) =>
            props.size === 'small'
                    ? props.theme.spacing(4)
                    : props.size === 'medium'
                            ? props.theme.spacing(6)
                            : props.size === 'xlarge'
                                    ? props.theme.spacing(14)
                                    : props.theme.spacing(12)} ;
  }
`;

Avatar.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
};

Avatar.defaultProps = {
  size: 'medium',
};

export default Avatar;
